import CardsPick from "./CardsPick"
import CardsReview from "./CardsReview"
import type { Phase } from "@/types"

/*
 * Two phases, two different people acting: the room picks, then the facilitator
 * curates. That is why they are separate phases in `ROUND_PHASES` rather than one
 * screen with a mode.
 *
 * The phase is a prop for the same reason it is in `Pains` — a finished round is
 * read back at the beat it was left on, which is not where the session is.
 */

interface CardsProps {
  phase: Phase
  canDrive: boolean
  readOnly: boolean
}

export default function Cards({ phase, canDrive, readOnly }: CardsProps) {
  if (phase === "review") return <CardsReview canDrive={canDrive} readOnly={readOnly} />
  return <CardsPick canDrive={canDrive} readOnly={readOnly} />
}
